import { createSelector } from 'reselect'
import sortBy from 'lodash.sortby'

const distributors = (state) => state.models.distributors

export const getDistributors = createSelector([distributors], (distributors) => {
  return sortBy(Object.values(distributors.byId), (o) => o.name.toLowerCase())
})
